module.exports = __webpack_public_path__ + "img/nq_icon1.91fddc1e.png";